import type { IndexClientDTO, IndexState, MutationClass } from '../../../models'
// @ts-strict-ignore
import Vue from 'vue'

export class SetClientMutation implements MutationClass {
  static execute(this: void, state: IndexState, client: IndexClientDTO): void {
    Vue.set(state.clients, client.id, client)
  }
}
